/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import ReactToPrint from 'react-to-print'
import $ from 'jquery'

class SmallPrint extends React.Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {}
  render() {
    var stylePrint = 'page{\n' + '  size:57.2mm 39.4mm;\n' + '  margin: 1.3mm;\n' + '\n' + '}'

    return (
      <div>
        <ReactToPrint
          copyStyles={false}
          pageStyle="
                    @page{
                        size:57.2mm 39.4mm;
                    }
                    .smallPrint{
                    text-align:center;
                    background:gray;
                    width:100%;
                    height:100%;
                    position:fixed;
                    top:0;
                    right:0;
                    }

                    "
          trigger={() => (
            <button className="printButton">
              <i className="fas fa-print" />
            </button>
          )}
          content={() => this.printPart}
        />
        <div className="rtl" ref={(node) => (this.printPart = node)}>
          <div className="wrapperIframe">
            <div className="smallPrint"> dassdassdadas</div>
            {/*<div className='printPart'>*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
    )
  }
}
export default SmallPrint
